'use client'

import { Box } from '@mui/material'
import { useSrpContext } from '@/src/contexts'

import PageIntroWrapper from './pageIntro'
import HeroSectionWrapper from './heroSection'
import FareHighlightsWrapper from './fareHighlights'
import CheapestBookingWrapper from './cheapestBooking'
import FareIntelligenceWrapper from './fareIntelligence'
import RouteGuideWrapper from './routeGuide'
import BestTimeToVisitWrapper from './bestTimeToVisit'
import PopularAirlinesWrapper from './popularAirlines'
import AirlineComparisonWrapper from './airlineComparison'
import PolicyComparisonWrapper from './policyComparison'
import AirportInfoWrapper from './airportInfo'
import DestinationInfoWrapper from './destinationInfo'
import PlacesToVisitWrapper from './placesToVisit'
import CategoryFaqWrapper from './categoryFaq'
import EditorialMetaWrapper from './editorialMeta'

const RouteSeoContentWrapper = () => {
    const {
        SEOSrpData: { meta, contentSource, sections }
    } = useSrpContext()

    const contentMode = meta?.contentMode ?? contentSource?.mode
    if (contentMode !== 'ai' || !sections) return null

    return (
        <Box sx={{ minWidth: 0, overflow: 'hidden', mt: 2 }}>
            {sections.hero && <HeroSectionWrapper />}
            {(sections.whenToBook?.fareSummary || sections.hero?.stats) && <FareHighlightsWrapper />}
            {sections.pageIntro && <PageIntroWrapper />}
            {sections.whenToBook && <CheapestBookingWrapper />}
            {sections.whenToBook?.fareOverview && <FareIntelligenceWrapper />}
            {sections.routeFacts && <RouteGuideWrapper />}
            {sections.climate && <BestTimeToVisitWrapper />}
            {sections.airlines?.overview && <PopularAirlinesWrapper />}
            {!!sections.airlines?.comparison?.length && <AirlineComparisonWrapper />}
            {!!sections.airlines?.policyTable?.length && <PolicyComparisonWrapper />}
            {!!sections.airports?.length && <AirportInfoWrapper />}
            {(sections.destinationTeaser?.summary || sections.destination?.info) && <DestinationInfoWrapper />}
            {!!(sections.destinationTeaser?.topPlaces?.length || sections.destination?.placesToVisit?.length) && <PlacesToVisitWrapper />}
            {!!sections.faq?.length && <CategoryFaqWrapper />}
            {sections.editorialMeta && <EditorialMetaWrapper />}
        </Box>
    )
}

export default RouteSeoContentWrapper
